import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import { useUnmount } from "app/custom-hooks/useUnmount";
import { searchResultsClearedAction } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/action-creators";
import { fetchContactsStatusThunk } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/effects";

import useRevealQuotaFetchEffect from "./useRevealQuotaFetchEffect";

export const useContactsStatusEffect = (): void => {
    const dispatch = useDispatch();

    useRevealQuotaFetchEffect();

    useMount(() => {
        void dispatch(fetchContactsStatusThunk());
    });

    useUnmount(() => {
        dispatch(searchResultsClearedAction({ areResultsFetching: false }));
    });
};
